export class UnifiedRestoreMicrosoft365Snapshot {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "presentEntityIds",
            "baseName": "presentEntityIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedRestoreMicrosoft365Snapshot.attributeTypeMap;
    }
    constructor() {
    }
}
